import gql from "graphql-tag";

export default gql`
	{
		CompanySettings {
			can_view_reports
			can_run_reports
			can_view_writebacks
			can_retry_writebacks
			can_export_data
			prevent_school_access_request
			enable_2fa
			request_access_limit
			revoke_access_limit
		}
	}
`;
